/**
 * @generated SignedSource<<6be5691619e3b10b9896fbc81a63bbaa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HeaderWithComplexMenuMobile_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HeaderAuthenticatedUser_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": "__isViewer"
};

node.hash = "c6bfa976354c0a77f7bf64f4d65160e5";

module.exports = node;
